export default {
  notSelected: 0,
  free: 1,
  pro: 2,
  contactUs: 3,
}
